/**
 * The GA4 branch of Explore's Data Sources list: sections as an accordion
 * (opening one closes the others, as in AgencyAnalytics) and their views as
 * links. Opens on the section of the view being shown.
 */

import { useEffect, useState, type ReactNode } from 'react';

import { hrefFor } from '../routes.ts';
import { findView, GA4_SECTIONS } from './ga4-views.ts';

export function ExploreTree(props: { clientId: string; activeView: string | null }): ReactNode {
  const [openSection, setOpenSection] = useState<string | null>(
    props.activeView ? findView(props.activeView).section.key : null,
  );
  // Moving to another view (a link, back/forward) opens that view's section.
  useEffect(() => {
    if (props.activeView) setOpenSection(findView(props.activeView).section.key);
  }, [props.activeView]);
  return (
    <ul className="ex-tree">
      {GA4_SECTIONS.map((section) => {
        const isOpen = openSection === section.key;
        const panelId = `ex-tree-${section.key}`;
        return (
          <li key={section.key}>
            <button
              type="button"
              className="ag-explore-link ex-tree-section"
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => setOpenSection(isOpen ? null : section.key)}
            >
              {section.title}
            </button>
            {isOpen && (
              <ul id={panelId}>
                {section.views.map((view) => {
                  const active = view.slug === props.activeView;
                  return (
                    <li key={view.slug}>
                      <a
                        className={`ag-explore-link ex-tree-view${active ? ' on' : ''}`}
                        aria-current={active ? 'page' : undefined}
                        href={hrefFor({
                          area: 'client',
                          clientId: props.clientId,
                          tab: 'dashboards',
                          documentId: null,
                          explore: view.slug,
                        })}
                      >
                        {view.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
}
